import { IconProps } from '../../Interfaces/Props';

const IconArrow2 = (props: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size ?? '18'}
      height={props.size ?? '18'}
      className={props.className}
      viewBox="0 0 12 24"
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M10.157 12.711L4.5 18.368l-1.414-1.414l4.95-4.95l-4.95-4.95L4.5 5.64l5.657 5.657a1 1 0 0 1 0 1.414"
      />
    </svg>
  );
};

export default IconArrow2;
